import { getDatasWithOption } from '../../utils/service';
import { BREAKPOINTS } from '../../model/model';
import { isChrome, isDefined, isObject, not, isNotDefined, each, truthy, falsy, parseInt10, isMobileResolution, getResolution } from '../../utils/util';
import SettingModel from './tpl';

class BeginnerTop {
  constructor(options) {
    const _ = this;

    if (!options) return;

    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      classId: 0,
      level: 0,
      global: window
    }, options);

    _.wrap = _.option.wrap;
    _.model = new SettingModel;

    _.global = (_.option.global) ? _.option.global : window;
    _.currentResolution = getResolution( BREAKPOINTS, window );

  }

  init() {

    console.log('BeginnerTop !! ');
    const _ = this;

    _.setClass();
    _.setMenu();
    _.setHelper()
    _.setQuickmenu();
    // return _;
  }

  setClass() {
    const _ = this,
      _level = _.option.level,
      _classId = _.option.classId;

    let _className = _.model.CLASS_NAMES[_classId]; // ex. 군주
    let _classMagicPowerbook = _.model.CLASS_MAGIC_POWERBOOK[_classId];
    let _classTypeText = (_classId == 1 || _classId >= 7) ? '기술' : '마법';

    console.log('_className : ', _className);
    $('.wrap-section-beginner').removeClass().addClass( 'wrap-section-beginner class-'+ _classId );
    $('.header-class', _.option.wrap.itemWrap ).append( _className );
    (_classId == 2 ) ? $('.header-class', _.option.wrap.magicWrap ).append( _className +'(바람 계열)') : $('.header-class', _.option.wrap.magicWrap ).append( _className );

    $('.btn-magic-powerbook', _.option.wrap.magicWrap ).html(`<span class="ico-p">powerbook</span><span class="button-class">${_className}</span> ${_classTypeText}`).attr('href', _classMagicPowerbook ); // ex. 군주or성기사 등 마법or기술 파워북
    

    let dropdown = nc.lineage.dropdown({
      wrap: $('.ui-dropdown-class'),
      activateIndex: _.option.classId+1,
      activateCallback: function (obj) {
        if(obj.index === _.option.classId+1) return;
        document.location.href = window.getUriCombinedParams(document.location.pathname, {
          classId: obj.index-1
        });
      },
      useDefaultSelectInMobileDevice: true
    });

  }

  setMenu() {
    const _ = this;
  }

  setHelper() {
    const _ = this;

    let _itemHelperHandler = $('.icon-helper', _.option.wrap.itemWrap ),
        _magicHelperHandler = $('.icon-helper', _.option.wrap.magicWrap ),
        _itemHelperWrap = _itemHelperHandler.siblings('.wrap-helper'),
        _magicHelperWrap = _magicHelperHandler.siblings('.wrap-helper'),
        _wrapItem = _.option.wrap.itemWrap.find('.wrap-helper') ; // $('.wrap-helper', _.option.wrap.itemWrap); /*,


    /*let helperInit = setTimeout( function(){
      _itemHelperWrap.fadeOut('fast');
      _magicHelperWrap.fadeOut('fast');
      _itemHelperHandler.removeClass('on');
      _magicHelperHandler.removeClass('on');
    }, 3000 ); */

    _itemHelperHandler.click(function(){
      //clearTimeout(helperInit);
      if( _itemHelperWrap.is(':visible') ) {
        _itemHelperWrap.fadeOut('fast');
        _itemHelperHandler.removeClass('on');
      }else {
        _itemHelperWrap.fadeIn('fast');
        _itemHelperHandler.addClass('on');
      }
    });

    _magicHelperHandler.click(function(){
      //clearTimeout(helperInit);
      if( _magicHelperWrap.is(':visible') ) {
        _magicHelperWrap.fadeOut('fast');
        _magicHelperHandler.removeClass('on');
      }else {
        _magicHelperWrap.fadeIn('fast');
        _magicHelperHandler.addClass('on');
      }
    });

  }

  setQuickmenu() {
    const _ = this;

    let _quickmenu = $('.quickmenu');
    let _quickbtn = $('.button-toggle', _quickmenu);
    let _quickitem = $('a', _quickmenu);

    console.log( ' _.currentResolution () : ',  _.currentResolution  );

    if(_.currentResolution == 'pc' || _.currentResolution == 'max') {
      _quickmenu.removeClass('off');
    }

    _quickbtn.click(function(e){
      e.preventDefault();
      _quickmenu.toggleClass('off');
    });



    _quickitem.click(function(e) {
      e.preventDefault();


      let _section = $(this).attr("class");
      let _itemOffset = $('.wrap-section-'+ _section).offset();
      let _quickOffsetTop = ( _.currentResolution == 'pc' || _.currentResolution == 'max' ) ? _itemOffset.top - 59 : _itemOffset.top - 106 ;


      _quickitem.removeClass('on');
      $(this).addClass('on');

      $("html, body").animate({
        scrollTop: _quickOffsetTop
      }, 500);


    });

    $(window).resize(function() {

      _.currentResolution = getResolution( BREAKPOINTS, window );
      if(_.currentResolution == 'pc' || _.currentResolution == 'max') {
        _quickmenu.removeClass('off');
      }else {
        _quickmenu.addClass('off');
      }

      // console.log( '_currentResolution : ', _.currentResolution );


    });




  }
}

export default BeginnerTop;


// WEBPACK FOOTER //
// ./_src/js/service/beginner/BeginnerTop.js